const dateBaseOn = { orderDate: 'OrderDate', eta: 'ETA', etd: 'ETD', ata: 'ATA', atd: 'ATD' };

export default dateBaseOn;
